import { Logger, DEFAULT_SEVERITY } from 'swp-react/logging';

let setup = false;
let uuid = crypto?.randomUUID?.();
let KNumber = null;
let retailerId = null;

let logger;

let LOG_QUEUE = [];

const createLogContext = () => ({
	timeStamp: new Date().toUTCString(),
	logType: 'moments-transfer',
});

export const clearQueue = (triggerQueue = true) => {
	if (LOG_QUEUE.length > 0 && triggerQueue) {
		console.log(
			`Found ${LOG_QUEUE.length} logs in queue.  Logging...`,
			LOG_QUEUE
		);

		LOG_QUEUE.forEach((log) => {
			if (log?.type && log?.entry) {
				if (log.type === 'page-view') {
					aiPageView(log.entry);
				} else {
					if (log?.entry?.logData && log?.entry?.logLevel) {
						const fullEntry = {
							...log.entry,
							retailerId,
							knumber: KNumber,
						};
						logger?.log(log?.entry?.logLevel, fullEntry);
					} else {
						console.error(
							'Invalid log entry found in queue.  This log will not appear in Application Insights:',
							log
						);
					}
				}
			}
		});

		LOG_QUEUE = [];
	}
};

export const createLogger = async (appId) => {
	try {
		setup = true;
		logger = Logger.initialize({
			logToConsole: true,
			logStructureOverride: {
				logLevel: 'string',
				logData: {},
				sessionId: 'string',
			},
			addLogContext: true,
			createLogContext: createLogContext,
			appInsightsConfig: {
				connectionString: appId,
				disableFetchTracking: true,
				disableAjaxTracking: true,
				cookieCfg: {
					enabled: false,
				},
			},
		});
	} catch (err) {
		console.error('LOGGER threw an unexpected exception:', err);
		setup = false;
	}
};

export const updateLoggerId = (newId) => {
	uuid = newId;
	logToAi(
		{
			message: `User ID received! Updating logger ID to match.`,
			id: 'DEBUG_UPDATE_UUID',
			location: 'logging.js:updateLoggerId',
			data: {
				oldUserId: uuid,
				userId: newId,
			},
		},
		'debug',
		false
	);
};

export const updateKnumber = (kn) => {
	KNumber = kn;
	logToAi(
		{
			message: `Knumber received! Updating logger knumber`,
			id: 'DEBUG_UPDATE_KNUMBER',
			location: 'logging.js:updateKnumber',
			data: {
				kNumber: kn,
			},
		},
		'debug',
		false
	);
};

export const updateRetailerId = (rid) => {
	retailerId = rid;
	logToAi(
		{
			message: `Retailer Id received! Updating logger retailerId`,
			id: 'DEBUG_UPDATE_RETAILER_ID',
			location: 'logging.js:updateRetailerId',
			data: {
				retailerId: rid,
			},
		},
		'debug'
	);
};

// track page view
export const aiPageView = (url) => {
	if (!logger || !Logger.instance || !logger.appInsights) {
		LOG_QUEUE.push({
			type: 'page-view',
			entry: url,
		});

		if (!setup) {
			console.warn(
				'Attempt to log page view before the logger was initialized.  This is not advised.'
			);
		}
	} else {
		logger.appInsights.trackPageView({
			url: url,
			id: uuid,
			properties: {
				retailerId,
				knumber: KNumber,
			},
		});
	}
};

export const logToAi = (
	msg,
	severity = DEFAULT_SEVERITY.DEBUG,
	triggerQueue = true
) => {
	const entry = {
		logLevel: severity,
		logData: msg,
		sessionId: uuid,
	};

	if (retailerId) {
		entry['retailerId'] = retailerId;
	}

	if (KNumber) {
		entry['knumber'] = KNumber;
	}

	if (!logger || !Logger.instance || !logger.appInsights) {
		LOG_QUEUE.push({
			type: 'log',
			entry: entry,
		});
		if (!setup) {
			console.warn(
				'Attempt to log before the logger was initialized.  This is not advised.'
			);
		}
	} else {
		logger.log(severity, entry);
		clearQueue(triggerQueue);
	}
};

export const fileArrayStats = (files) => {
	const filesStats = files.reduce(
		(stats, file) => ({
			totalFilesSize:
				stats.totalFilesSize +
				(typeof file?.size === 'number' && file?.size ? file.size : 0),
			filesMimeTypes: stats.filesMimeTypes?.includes(file?.type)
				? stats.filesMimeTypes
				: [...stats.filesMimeTypes, file?.type],
		}),
		{
			totalFilesSize: 0,
			filesMimeTypes: [],
		}
	);

	filesStats.totalFilesSize =
		(filesStats.totalFilesSize / 1000000).toFixed(2) + ' MB';
	filesStats.totalFiles = files.length;

	return filesStats;
};
